import React from "react";
// Asumiendo que importas tus colores de la misma forma o los tienes definidos
const colors = { primary: "#007AFF" }; 

export default function ScheduleIntervalItem({ item, onPress, isActive }) {
  return (
    <button
      onClick={() => {
        onPress({ ...item });
      }}
      style={{
        padding: "8px",
        border: `1px solid ${colors.primary}`,
        borderRadius: "8px",
        backgroundColor: isActive ? colors.primary : "transparent",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "4px", // Combinamos vertical y horizontal en un margen general
        cursor: "pointer",
        flex: 1,
        transition: "all 0.2s ease", // Pequeña animación de color
        outline: "none",
        width: "100%" // Para que llene la celda del grid en el modal
      }}
    >
      <span
        style={{
          textAlign: "center",
          color: isActive ? "#fff" : colors.primary,
          fontSize: "11px",
          fontWeight: 500,
          whiteSpace: "nowrap" // Evita que el texto se rompa en dos líneas
        }}
      >
        {`${item.start} - ${item.end}`}
      </span>
    </button>
  );
}